import './ProgressBar.scss';

type Props = {
  percentile: number;
  backgroundColor?: string;
};

const ProgressBar = ({ percentile, backgroundColor }: Props) => {
  return (
    <div className='ProgressBar'>
      <div className='ProgressBar-fill' style={{ transform: `translateX(${-100 + percentile}%)`, backgroundColor: backgroundColor }} />
    </div>
  );
};

export default ProgressBar;
